import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	shareButtonLabel: {
		id: 'share-button.ui.share-view.share-button-label.non-final',
		defaultMessage: 'Share',
		description: 'Label for the share button',
	},
	copyLinkLabel: {
		id: 'share-button.ui.share-view.copy-link-label.non-final',
		defaultMessage: 'Copy link',
		description: 'Label for the copy link button',
	},
});
